import { useEffect, useState } from 'react';
import ProfileTabs from './ProfileTabs';
import PersonalInfo from './PersonalInfo';
import AddressSection from './AddressSection';
import SecuritySection from './SecuritySection';
import Favoritesection from './Favoritesection';
import FollowupSection from './FollowupSection';
import MeusPedidos from './Meus-Pedidos';
import { useLocation } from 'react-router-dom';

import { 
 User
} from "lucide-react";

function Profile() {
  const [activeTab, setActiveTab] = useState('informacoes');
  const location = useLocation();

  useEffect(() => {
    // Extrai o parâmetro `tab` da URL (ex: /minha-conta?tab=informacoes)
    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get('tab');

    // Se o parâmetro `tab` existe e é válido, atualiza a `activeTab`
    if (tab && ['informacoes', 'enderecos', 'seguranca', 'favoritos', 'entrega', 'meus-pedidos'].includes(tab)) {
      setActiveTab(tab);
    }
  }, [location.search]); // Executa sempre que a URL muda

  return (
    <div className="w-full mb-[5%] mt-5 md:mt-24">
       <div className=" flex ml-[3%]  mt-[3%] ">
        <User className="h-8 w-8 mr-2" />
      <h1 className="text-2xl font-bold">Minha Conta </h1>
      </div>

      <div className="p-4">
      <ProfileTabs activeTab={activeTab} setActiveTab={setActiveTab} />
      {/* //seções apareceram aq  */}
      {activeTab === 'informacoes' && <PersonalInfo />}
      {activeTab === 'enderecos' && <AddressSection />}
      {activeTab === 'seguranca' && <SecuritySection />}
      {activeTab === 'favoritos' && <Favoritesection />}
      {activeTab === 'entrega' && <FollowupSection />}
      {activeTab === 'meus-pedidos' && <MeusPedidos />}


    </div>

    </div>
  );
}

export default Profile;